const blogData = [
  {
    date: "22.03.2022",
    heading: "New Strength Training Classes",
    paragraphText:
      "Join our latest strength training classes designed to help you build muscle, increase endurance, and achieve your fitness goals.",
  },
  {
    date: "25.03.2022",
    heading: "Nutrition Workshop: Fuel Your Workout",
    paragraphText:
      "Learn about the importance of nutrition in enhancing your workout performance. Discover the best foods to fuel your body for optimal results.",
  },
  {
    date: "28.03.2022",
    heading: "Specialized Cardio Programs",
    paragraphText:
      "Introducing specialized cardio programs tailored to boost your cardiovascular health. Join us for high-energy workouts and improve your endurance.",
  },
];

export default blogData;
